import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import {
  SellAllPositionsButton,
  SellPositionButton,
} from '@root/features/trade/position/sell-position/ui'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type FavoriteActionsCellProps = {
  pair: PairModel
} & ClassNameProps

export const FavoriteActionsCell: React.FC<FavoriteActionsCellProps> = ({
  className,
  pair,
}) => {
  const [position] = useAtom(pair.position)

  return (
    <Root className={className}>
      <SellPositionButton position={position} />
      <SellAllPositionsButton position={position} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
`
